import { render, staticRenderFns } from "./product-item-detail.vue?vue&type=template&id=70079b5e&"
import script from "./product-item-detail.vue?vue&type=script&lang=js&"
export * from "./product-item-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports